import React, {useEffect, useState} from 'react';
import PinInput from "react-pin-input";
import connectLogo from './assets/Logo.svg'
import machineQrCode from './assets/machine_qrcode_example.png'
import machineCodeLabel from './assets/machine_code_example.png'
import {useNavigate} from "react-router-dom";
import {grpcAPI} from "./api";


function DashboardPage() {
    const [machineCode, setMachineCode] = useState("")
    const [isFindingVendingMachine, setIsFindingVendingMachine] = useState(false)
    const navigate = useNavigate()

    const findVendingMachine = (machineCode:string)=>{
        setIsFindingVendingMachine(true);
        const apiService = new grpcAPI();
        apiService.hivTestAPIServiceFindVendingMachine({
            machineCode:machineCode
        }).then((response)=>{
            if (response.data.found){
                setIsFindingVendingMachine(false);
                navigate(`/machines/${response.data.vendingMachineId}`, {replace: true})
            } else {
                window.alert("Vending Machine does not exist.")
            }
        }).catch((result)=>{
            window.alert("Unknown server error, please retry")
        }).finally(()=>{
            setIsFindingVendingMachine(false);
        })
    }

    const queryCustomerEligibilityStatus = () => {
        const apiService = new grpcAPI();
        apiService.hivTestAPIServiceCheckUserEligibility({}).then((response)=>{
            if (!response.data.eligible){
                navigate(`/cooling_off`, {replace: true})
            }
        })
    }

    useEffect(queryCustomerEligibilityStatus, [])  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            {/* Header */}
            <div className={"backgroundPrimary pt-4 pb-3"}>
                <div className={"container"}>
                    <div className={"text-center pb-3"}>
                        <img src={connectLogo} alt="Connect" style={{maxWidth: "160px"}} />
                    </div>
                    <p className={"dashboardSubtitle mb-2"}>Get a Test Kit</p>
                    <h1 className={"dashboardHeadingLarge"}>If you are in front of the&nbsp;machine now:</h1>
                </div>
            </div>

            {/* Main content */}
            <div className={"container pt-3 pb-4"}>
                {/* QR Scan Card */}
                <div className={"optionCard"}>
                    <img src={machineQrCode} alt="Vending machine with QR code" />
                    <div className={"cardContent"}>
                        <p className={"mb-0 cardBoldText"}>
                            Scan the QR code using your phone's camera
                        </p>
                    </div>
                </div>

                {/* "or" divider */}
                <div className={"orDivider"}>
                    <div className={"orDivider-line"} />
                    <span>or</span>
                    <div className={"orDivider-line"} />
                </div>

                {/* Inline Code Entry */}
                <div className={"optionCard"}>
                    <img src={machineCodeLabel} alt="Machine number label on machine" />
                    <div className={"cardContent d-flex flex-column"}>
                        <p className={"mb-1 cardBoldText"}>
                            Enter the machine number:
                        </p>
                        <p className={"cardSubText mb-0"}>
                            You can find this under the QR code.
                        </p>
                        <div className={"mt-auto pt-2"}>
                        <PinInput
                            length={4}
                            initialValue={machineCode}
                            secret={false}
                            onChange={(value:string) => { setMachineCode(value) }}
                            type={"numeric"}
                            inputMode="number"
                            style={{
                                display: "flex",
                                gap: "8px"
                            }}
                            inputStyle={{
                                background: "#FFFFFF",
                                border: "1px solid #DDDDDD",
                                boxSizing: "border-box" as const,
                                borderRadius: "8px",
                                width: "44px",
                                height: "44px",
                                fontSize: "18px",
                                textAlign: "center" as const,
                            }}
                            inputFocusStyle={{
                                background: "#FFFFFF",
                                border: "2px solid #FFC600",
                                boxSizing: "border-box" as const,
                                borderRadius: "8px",
                            }}
                            onComplete={(value:string) => { findVendingMachine(value) }}
                            autoSelect={true}
                            regexCriteria={/^[0-9]*$/}
                        />
                        {isFindingVendingMachine && (
                            <div className={"pt-2"}>
                                <i className="fas fa-spinner fa-spin"/> <span className={"textSecondary"} style={{fontSize: "14px"}}>Finding machine...</span>
                            </div>
                        )}
                        </div>
                    </div>
                </div>

                {/* Divider */}
                <div style={{height: "1px", backgroundColor: "#CCCCCC", margin: "24px 0"}} />

                {/* Help Section */}
                <h2 className={"dashboardHeadingLarge mb-3"} style={{fontSize: "22px", lineHeight: "28px"}}>
                    If you need help finding a vending&nbsp;machine:
                </h2>
                <div className={"machineListCard"} onClick={() => { navigate("/machines") }}>
                    <span>See a list of machine locations</span>
                    <span className={"arrow"}>&rarr;</span>
                </div>
            </div>
        </div>
    );
}

export default DashboardPage;
